import { render, staticRenderFns } from "./GatewaysFiat.vue?vue&type=template&id=6d71c80a&scoped=true"
import script from "./GatewaysFiat.vue?vue&type=script&lang=js"
export * from "./GatewaysFiat.vue?vue&type=script&lang=js"
import style0 from "./GatewaysFiat.vue?vue&type=style&index=0&id=6d71c80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71c80a",
  null
  
)

export default component.exports